import React from 'react';

import * as RadixAccordion from '@radix-ui/react-accordion';

import { ChevronDownIcon } from '@radix-ui/react-icons';
import { getDisableIconClasses } from '../icons/getDisableIconClasses';

export const Root = React.forwardRef<
  HTMLDivElement,
  RadixAccordion.AccordionSingleProps | RadixAccordion.AccordionMultipleProps
>((props, ref) => (
  <RadixAccordion.Root {...props} ref={ref} className="w-full" />
));

export const Item = React.forwardRef<
  HTMLDivElement,
  RadixAccordion.AccordionItemProps
>((props, ref) => <RadixAccordion.Item {...props} ref={ref} />);

export const Trigger = React.forwardRef<
  HTMLButtonElement,
  RadixAccordion.AccordionTriggerProps
>(({ children, ...props }, forwardedRef) => (
  <RadixAccordion.Header className="flex">
    <RadixAccordion.Trigger
      {...props}
      ref={forwardedRef}
      className="group flex flex-1 items-center justify-between"
    >
      {children}
      <ChevronDownIcon
        className={`${getDisableIconClasses(props.disabled)} h-5 w-5 transition-transform duration-300 ease-[cubic-bezier(0.87,0,0.13,1)] group-data-[state=open]:rotate-180`}
      />
    </RadixAccordion.Trigger>
  </RadixAccordion.Header>
));

export const Content = React.forwardRef<
  HTMLDivElement,
  RadixAccordion.AccordionContentProps
>(({ children, ...props }, forwardedRef) => (
  <RadixAccordion.Content {...props} ref={forwardedRef}>
    {children}
  </RadixAccordion.Content>
));
